import { useEffect } from 'react';
import googleAnalyticsService from '../../services/GoogleAnalyticsService';
import { getHeaderVersion } from '../../util/getHeaderVersion';

const useTrackSearchTerm = (searchTerm: string, searchSource: 'header') => {
    useEffect(() => {
        if (!searchTerm || searchTerm.length < 2) {
            return;
        }

        if (googleAnalyticsService.isInHeaderExperiment()) {
            googleAnalyticsService.trackEvent('search', {
                header_version: getHeaderVersion(),
                search_source: searchSource,
                search_term: searchTerm,
            });
        }
    }, [searchTerm, searchSource]);

    return null;
};

export default useTrackSearchTerm;
